import { clearPassword, setPassword } from '../Utils/Password';
import { clearToken, setToken } from '../Utils/Token';
import graphql from './graphql';

export const changePassword = async (oldPassword, newPassword) => {
  const response = await graphql('User_changePassword', 'isFirstTime transactionStatus', 'mutation', {
    oldPassword,
    newPassword,
  });

  if (response.transactionStatus) {
    clearPassword();
  }

  return response;
};

/**
 * Fetch the currently logged user. Backend now surfaces auth failures through
 * the standard `errors[].extensions.code` channel; the graphql wrapper
 * translates that into `{ error, errorCode }` and clears the local token for
 * UNAUTHORIZED / USER_NOT_FOUND, so PrivateRoute can bounce to /login.
 */
export const getLoggedUser = async () =>
  graphql('User_logged', 'fullName telephone age payrollNum isFirstTime id roleId email photo');

export const login = async (payrollNum, password = '') => {
  setToken(null);
  const response = await graphql(
    'User_login',
    'token fullName telephone age payrollNum isFirstTime id status roleId Role { id }',
    'mutation',
    {
      payrollNum,
      password,
    }
  );

  if (!response.error) {
    setToken(response.User_login.token);
    setPassword(password);
  }

  return response;
};

export const logOut = async () => {
  let response = await graphql('User_logOut', 'transactionStatus', 'mutation');

  response = response.User_logOut;

  clearToken();

  return response;
};
